import React, { useContext } from 'react';
import { context } from '@dialinvest/react-casino';
import PropTypes from 'prop-types';
import SignupDispatcher from './Signup/SignupDispatcher';
import Signin from './Signin';
import Cashier from './Cashier';
import SupportPanel from './SupportPanel';
import ResendVerificationCode from './ResendVerificationCode';
import PasswordResetRequest from './PasswordResetRequest';
import PasswordReset from './PasswordReset';
import Transactions from './Transactions';
import VipApply from './VipApply';
import EmailSent from './EmailSent';
import ErrorModal from './ErrorModal';
import { needHeaderFooter } from '../Helpers';
import ConnectionErrorPopUp from './ConnectionErrorPopUp';
import LoyaltyShop from './LoyaltyShop';

const ModalWrapper = ({ children }) => {
  const { PageContext } = context;
  const { pageType } = useContext(PageContext);


  return (
    <>
      {children}
      <SignupDispatcher />
      <ResendVerificationCode />
      <PasswordResetRequest />
      <PasswordReset />
      <Signin />
      <Transactions />
      {needHeaderFooter(pageType) && <SupportPanel />}
      <Cashier />
      <VipApply />
      <EmailSent />
      <ConnectionErrorPopUp />
      <LoyaltyShop />
      <ErrorModal />
    </>
  );
};

ModalWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ModalWrapper;
